var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1986 0.235046L12.1264 1.38695L5.206 8.74307L4.13381 13.2739L8.39179 12.8164L8.39298 12.8179L8.39458 12.8161L8.42258 12.8131L8.41098 12.7982L11.6264 9.36818V9.36821L13.1556 7.73709V7.73706L15.311 5.43778V2.97111L15.2873 2.99668L13.1986 0.235046ZM13.1556 4.5344L13.4758 4.95778L14.2067 4.15987L13.1006 2.79847L12.5771 3.37097H12.5772L12.4122 3.55141L13.1556 4.53436V4.5344ZM11.0596 5.02145L6.29371 10.0486L5.84932 11.6612L7.35038 11.4308L7.36029 11.4436L12.3985 6.13372L11.2928 4.77557L11.0596 5.02145H11.0596ZM13.1556 9.46439L11.6264 11.0955V15.5846H1.84014V5.02145H7.0746L8.62734 3.37097H0.311035V17.235H13.1556V9.46439Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.904daf7cdba73240392c9994b6d009ad.svg";
export { ForwardRef as ReactComponent };